import * as Yup from "yup";

export const badlaInstrumentCreateSchema = Yup.object().shape({
  settingName: Yup.string().trim().required("setting name is required"),
  equation: Yup.string().trim().required("equation is required"),
  Duty: Yup.number().required("duty is required"),
  badlaType: Yup.object().required("Select Any badla Type"),
  MCX_Exchnage: Yup.object().required("Select Any MCX Exchnage"),
  COMEX_Exchnage: Yup.object().required("Select Any COMEX Exchnage"),
  DGCX_Exchange: Yup.object().required("Select Any DGCX Exchange"),
});

export const badlaSettingCreateSchema = Yup.object().shape({
  settingName: Yup.string().trim().required("setting name is required"),
  remark: Yup.string().trim().required("remark is required"),
  defaultValue: Yup.number().required("default value is required"),
});
